module.exports = __webpack_public_path__ + "static/media/Alert-Circled.a2fae592.png";